import clsx from 'clsx';
import type { ComponentPropsWithRef, ReactNode } from 'react';
import { forwardRef, useEffect, useState } from 'react';
import type { FieldError } from 'react-hook-form';

type CheckboxProps = Omit<ComponentPropsWithRef<'input'>, 'className'> & {
  label?: string | ReactNode;
  tooltip?: ReactNode;
  classNames?: {
    root?: string;
    input?: string;
    label?: string;
  };
  fieldError?: FieldError;
};

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  (props, ref) => {
    const { classNames, label, tooltip, fieldError, ...inputProps } = props;
    const [tooltipElement, setTooltipElement] = useState<ReactNode>(<></>);

    useEffect(() => {
      if (tooltip) {
        setTooltipElement(tooltip);
      }
    }, [tooltip]);

    return (
      <>
        <label className={clsx('ckbox', classNames?.root)}>
          <input
            ref={ref}
            type="checkbox"
            className={classNames?.input}
            {...inputProps}
          />
          <span className={classNames?.label}>{label}</span>
          {tooltipElement}
        </label>
        {fieldError && (
          <ul className="parsley-errors-list mg-b-minus-8 pd-l-25">
            <li className="parsley-type">{fieldError.message}</li>
          </ul>
        )}
      </>
    );
  }
);
Checkbox.displayName = '@signate-cloud/Checkbox';
